import React from 'react';
import ContentLoader from 'react-content-loader';
import TicketSectionSkeleton from '../TicketSection/TicketSectionSkeleton';
import { isRenderedInsideEmbed } from 'utils/isRenderedInsideEmbed';

const TicketSaleCardSkeleton: React.FC<{}> = () => (
  <div
    className={`ticket-sale-card-skeleton w-full mx-auto md:max-w-[656px] ${
      isRenderedInsideEmbed ? '' : 'rounded-lg shadow-md overflow-hidden'
    }`}
  >
    <div
      className="p-[12px] sm:py-[16px] sm:px-[24px] bg-neutral-10 border-b border-neutral-40"
      style={{ background: 'var(--cardTitleBackground)' }}
    >
      <ContentLoader
        width="100%"
        height={77}
        backgroundColor="var(--neutral-200)"
        foregroundColor="var(--neutral-400)"
      >
        <rect
          x="0"
          y="0"
          rx="8"
          ry="8"
          width="100%"
          height="100%"
          className="m-[16px]"
        />
      </ContentLoader>
    </div>
    <div style={{ background: 'var(--cardContentBackground)' }}>
      <div className="p-[12px] sm:p-[24px] border-b border-neutral-40">
        <ContentLoader
          width="100%"
          height={64}
          backgroundColor="var(--neutral-200)"
          foregroundColor="var(--neutral-400)"
        >
          <rect
            x="0"
            y="0"
            rx="8"
            ry="8"
            width="70"
            height="20"
            className="mb-[4px]"
          />
          <rect x="0" y="24" rx="8" ry="8" width="100%" height="39" />
        </ContentLoader>
      </div>
      <TicketSectionSkeleton />
      <TicketSectionSkeleton />
      <div className="p-[12px] sm:py-[16px] sm:px-[24px] border-b border-neutral-40">
        <div className="w-[112px] ml-auto">
          <ContentLoader
            width="100%"
            height={36}
            backgroundColor="var(--neutral-200)"
            foregroundColor="var(--neutral-400)"
          >
            <rect
              x="0"
              y="0"
              rx="8"
              ry="8"
              width="100%"
              height="36"
              className="ml-auto"
            />
          </ContentLoader>
        </div>
      </div>
    </div>
  </div>
);

export default TicketSaleCardSkeleton;
